import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';

const InputFieldCheckbox = props => {
  const { inputAttributes, message, customChangeHandler } = props;
  const {
    type,
    checked
  } = inputAttributes;

  const finalInputAttributes = {
    ...inputAttributes,
    'aria-invalid': !!message
  };

  let iconName = null;

  switch (type) {
    case 'checkbox':
      iconName = 'check';
      finalInputAttributes.checked = inputAttributes.value;

      if (customChangeHandler) {
        finalInputAttributes.onChange = function () {
          const { value: currentValue } = finalInputAttributes;
          customChangeHandler({ value: !currentValue });
        };
      }

      break;

    case 'radio':
      iconName = 'check';

      if (checked) {
        finalInputAttributes.checked = true;
      }

      break;

    default:
      throw new Error(`invalid checkbox type "${type}"`);
  }

  return (
    <React.Fragment>
      <input {...finalInputAttributes} />
      <div className='checkmark-wrap' aria-hidden>
        <div className='checkmark'>
          <Icon iconName={iconName} />
        </div>
      </div>
    </React.Fragment>
  );
};

InputFieldCheckbox.propTypes = {
  inputAttributes: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]).isRequired,
    checked(props, propName, componentName) {
      const isChecked = props[propName];
      const { type } = props;

      switch (type) {
        case 'radio':
          if (isChecked && typeof (isChecked) !== 'boolean') {
            return new Error(`Invalid value type for "checked" prop in ${componentName}`);
          }
          break;

        case 'checkbox':
          if (isChecked !== undefined) {
            return new Error(
              `You need to check the checkbox by providing "boolean" value instead of "checked" prop in ${
                componentName
              }`
            );
          }
          break;

        default:
          return new Error(`invalid checkbox type "${type}"`);
      }
    }
  }).isRequired,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]).isRequired,
  message: PropTypes.object,
  customChangeHandler: PropTypes.func
};

export default InputFieldCheckbox;